export default __webpack_public_path__ + "static/media/osrcg02_2.d7b5eb5f.png";